module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_troms_og_finnmark_pos.62a0b71a.svg";